// extracted by css-extract-rspack-plugin
export default {"tableBody":"LedgerAccounts_tableBody__nWlIh"};